import Vue from 'vue'
import App from './App.vue'
import router from './router'
import dataV from '@jiaminghi/data-view'
// import ElementUI from 'element-ui'
import './plugins/element.js'
import locale from '@/utils/locale'

// 导入全局样式表
import './assets/css/global.css'

//import cytoscape from 'cytoscape';
//Vue.prototype.$cytoscape = cytoscape;

Vue.config.productionTip = false
Vue.use(dataV)
// Vue.use(ElementUI)
Vue.use(locale);

if (window.location.href.indexOf('lang=cn') > 0) {
  Vue.prototype.language = 'cn'
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
